import React, { useState, useEffect, useRef} from 'react';

// Styles
import './frame181.css';


function BannerMarquee({
    namedstrings,
    frameInfo
}) {
    if(! Array.isArray(frameInfo.frameData) || frameInfo.frameData.length == 0) {
        return null;
    }

    const slideMoveInterval = 7000;             // time to move the slide in milliseconds.
    const slideProgressUpdateInterval = 50;     // time interal between slide progress updates, in milli seconds.  better slideMoveInterval/slideProgressUpdateInterval is an integer.
    const frameIdWithNewStyle = 6392;

    const [currentImageIndex, setCurrentImageIndex]   = useState(0);
    const [paused, setPaused] = useState(false);
    const [hover, setHover] = useState(false);
    const [timePassed, setTimePassed] = useState(0);
    const [visible, setVisible] = useState(true);

    const wheelTimeout = useRef(null);
    const [isHandlingWheel, setIsHandlingWheel] = useState(false);

    const startX = useRef(null);
    const isDragging = useRef(false);

    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const frameRef = useRef(null);

    const enableImgFocalPoint = frameInfo.enableImgFocalPoint;

    function navBarClicked(i, track) {
        if (typeof(track) == 'undefined') { track = false;}

        let frameDiv = frameRef.current;
        let placeHolderImg = frameDiv.querySelector(".placeholder_img")
        
        if (currentImageIndex == i) return;
        if (i < 0 || i >= frameInfo.frameData.length) return;

        placeHolderImg.src = frameInfo.frameData[i].imageUrl;

        let oldimg = frameDiv.querySelector(".image" + currentImageIndex);
        let newimg = frameDiv.querySelector(".image" + i);
        oldimg.style.display = 'block';
        newimg.style.display = 'block';
        oldimg.style.zIndex = 1;
        newimg.style.zIndex = 0;
        oldimg.style.opacity = 0;
        newimg.style.opacity = 1;

        frameDiv.querySelectorAll('.bar').forEach((el, i) => {el.classList.remove = 'selected';})
        frameDiv.querySelector(".bar" + i).classList.add('selected');

        if (track) {
            trackNavbarClick(i);
        }

        setTimeout(function(){
            oldimg.style.display = 'none';
            newimg.style.display = 'block';
        }, 510);

        setCurrentImageIndex(i);
        setTimePassed(0);
    }

    function pauseBtnClicked() {
        let frameDiv = frameRef.current;
        trackNavButtonClick('pause');
        setPaused(true);
    }

    function playBtnClicked() {
        let frameDiv = frameRef.current;
        trackNavButtonClick('play');
        setPaused(false);
    }

    function imageDivClicked(e) {
        if (isDragging.current) {
            console.log('image clicked disabled since dragging')
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        
        //console.log('image clicked');
        //e.preventDefault();
        //e.stopPropagation();

        let linkEle = e.currentTarget;

        if (linkEle && !linkEle.getAttribute('href')) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (linkEle && typeof(frameImgClick) == 'function'){
            frameImgClick(e.currentTarget);
        }
    }

    function checkVisible() {
        const observer = new IntersectionObserver(
            ([entry]) => {
                //console.log('frame 181 visible ' + (entry.isIntersecting ? 1 : 0));
                setVisible(entry.isIntersecting)
            },
            {
                threshold: 0.1, // Trigger when 10% of the element is visible
            }
        );

        //console.log('observe', frameRef.current);
        if (frameRef.current != null) {
            observer.observe(frameRef.current);
        }
    }

    function isGestureAllowed() {
        return true;
        //return (typeof(gesture181) != 'undefined' && gesture181 == 1);
    }

    const handleMouseEnter = (e) => {
        if (typeof(g_is_mobile) != 'undefined' && g_is_mobile) {return}; 
        setHover(true); 
    }

    const handleMouseLeave = (e) => {
        setHover(false);
    }

    // desktop touch pad. 
    const handleWheel = (e) => {
        if (! isGestureAllowed()) { return;}

        //const isTouchpad = e.deltaMode === 0 && (Math.abs(e.deltaX) > 0 || Math.abs(e.deltaY) < 50);            //mode 0:  pixel unites,  mode 1 line units
        //console.log('wheel4', e.deltaX, e.deltaY, e.deltaMode, isTouchpad);
        //e.preventDefault();
        //e.stopPropagation();

        const { deltaX, deltaY } = e;

        if (Math.abs(deltaX) > 0) {                             // stop the deafault back to previous page behavior.
            e.preventDefault();
        }

        const timeWindow = 300;                                   //ms. 
        if (isHandlingWheel) {
            clearTimeout(wheelTimeout.current);
            wheelTimeout.current = setTimeout(() => {
                setIsHandlingWheel(false);
            }, timeWindow);
            return;
        };

        setIsHandlingWheel(true);
        const threshold = 0;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                move(1);
            } else {
                move(-1);
            }
        }

        wheelTimeout.current = setTimeout(() => {
            setIsHandlingWheel(false);
        }, timeWindow);

        /*
        if (isHandlingWheel) return;
        if (isTouchpad) {
            const threshold = 15;
            if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) {
                setIsHandlingWheel(true);
                if (deltaX > 0) {
                    console.log('Swiped left');
                } else {
                    console.log('Swiped right');
                }
                wheelTimeout.current = setTimeout(() => {
                    setIsHandlingWheel(false);
                }, 1000);
            }
        }
        else {
            setIsHandlingWheel(true);
            if (deltaY > 0) {
                console.log('wheel up');
            } else {
                console.log('wheel down');
            }
            wheelTimeout.current = setTimeout(() => {
                setIsHandlingWheel(false);
            }, 1000);
        }
        */

    }

    // step can be 1 or -1
    const move = (step) => {
        // todo:  add ismoving check?
        if (frameInfo.frameData.length > 1) {
            if (step == 1) {
                if (currentImageIndex >= frameInfo.frameData.length - 1) {
                    navBarClicked(0);
                }
                else {
                    navBarClicked(currentImageIndex + 1);
                }
            } else if (step == -1) {
                if (currentImageIndex >= 1) {
                    navBarClicked(currentImageIndex - 1);
                }
                else {
                    navBarClicked(frameInfo.frameData.length - 1);
                }
            }
        }
    }


    // deskop drag move.
    const handleMouseDown = (e) => {
        if (! isGestureAllowed()) { return;}

        startX.current = e.clientX;
        isDragging.current = false;
    };

    const handleMouseMove = () => {
        if (! isGestureAllowed()) { return;}

        isDragging.current = true;
    };


    const handleMouseUp = (e) => {
        if (! isGestureAllowed()) { return;}

        e.preventDefault();
        e.stopPropagation();

        console.log('mouse up', startX.current);
        if (startX.current === null) {
            return;
        }

        const endX = e.clientX;
        const deltaX = endX - startX.current;
        const threshold = 20;

        if (Math.abs(deltaX) > threshold) {
            if (deltaX > 0) {
                move(-1);
            } else {
                move(1);
            }
        } else {
            //console.log('Click (no significant drag)', e);
        }

        startX.current = null;
    };


    // mobile touch move.
    const handleTouchStart = (e) => {
        if (! isGestureAllowed()) { return;}

        touchStartX.current = e.targetTouches[0].clientX;
    };

    const handleTouchMove = (e) => {
        if (! isGestureAllowed()) { return;}

        touchEndX.current = e.targetTouches[0].clientX;
    };

    
    const handleTouchEnd = () => {
        if (! isGestureAllowed()) { return;}

        if (!touchStartX.current || !touchEndX.current) return;

        const distance = touchStartX.current - touchEndX.current;
        const threshold = 50; 
        if (distance > threshold) {
            move(1);
        } else if (distance < -threshold) {
            move(-1);
        } else {
            //console.log('Tap or short swipe');
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    function getFrameInfo(i) {
        let frameDiv = frameRef.current;
        let img = frameDiv.querySelector(".image" + i);
        if (img) {

            return {
                //pageframeId: img.getAttribute('data-pageframeid'),
                //frameId: img.getAttribute('data-frameid'),
                //frameItemId: img.getAttribute('data-frameitemid'),
                //frameItemTitle: img.getAttribute('data-frameitemtitle'),
                ctaName: `pageframeId:${img.getAttribute('data-pageframeid')}|frameId:${img.getAttribute('data-frameid')}|frameItemId:${img.getAttribute('data-frameitemid')}|frameItemTitle:${img.getAttribute('data-frameitemtitle')}`,
                ctaType: 'image',
                barPosition: (i * 1 + 1)
            };
        }
        return null;
    }

    function trackNavbarClick(i) {
        let params = getFrameInfo(i);
        params.ctaName = 'Carousel_Nav_Bar_Click - ' + params.ctaName
        if (params && typeof(adobeSatelliteTracking) == 'function') {
            adobeSatelliteTracking('Carousel_Nav_Bar_Click', params);
        }
    }

    function trackNavButtonClick(action){
        if (action != 'play' && action != 'pause') return;

        let params = getFrameInfo(currentImageIndex);
        params.ctaName = 'Carousel_Action - ' + params.ctaName
        params.action = action;
        if (params && typeof(adobeSatelliteTracking) == 'function') {
            adobeSatelliteTracking('Carousel_Action', params);
        }
    }


    /*
    useEffect(() => {
        const handleMouseUp = (e) => {
            console.log('doc mouseup');
        };

        document.addEventListener('mouseup', handleMouseUp);
        return () => document.removeEventListener('mouseup', handleMouseUp);
    }, []);
    */



    useEffect(() => {
        if (frameInfo.frameData.length <= 1) {
            return;
        }

        const frameDiv = frameRef.current;
        frameDiv.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            frameDiv.removeEventListener('wheel', handleWheel);
            clearTimeout(wheelTimeout.current);
        }
    }, [isHandlingWheel]);


    if (timePassed >= slideMoveInterval - 1) {
        setTimePassed(0);
        if (frameInfo.frameData.length > 1) {
            if (currentImageIndex >= frameInfo.frameData.length - 1) {
                navBarClicked(0);
            }
            else {
                navBarClicked(currentImageIndex + 1);
            }
        }
    }
    checkVisible();

    useEffect(() => {
        if (frameInfo.frameData.length <= 1) {
            return;
        }

        if (paused) { return; }
        // if (hover) {return;}                                              // disable on hover pause.
        if (! visible) {return;}

        const interval = setInterval(function(){
            //console.log('zzz' + timePassed);
            setTimePassed(prevTimePassed => prevTimePassed + slideProgressUpdateInterval);
        }, slideProgressUpdateInterval);

        return () => clearInterval(interval);
    }, [paused, hover, visible]);

    let hiddenImageStyle = {display: 'none', opacity:0};
    let visibleImageStyle = {display: 'block', opacity:1}

    return (
        <div
            ref={frameRef} 
            className={"frame181_div style" + (frameInfo.pageFrameId > frameIdWithNewStyle ? "new" : "old" ) }
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            data-pageframeid={frameInfo.pageFrameId}
        >
            <div className="frame_content" draggable="false">

                {Array.isArray(frameInfo.frameData) && frameInfo.frameData[0] &&
                    <img className='placeholder_img img'  src={frameInfo.frameData[0].imageUrl} alt={frameInfo.frameData[0].imgTitle} />
                }

                <div className="images_div" draggable="false" >
                    {Array.isArray(frameInfo.frameData) && frameInfo.frameData.map((fi, i) => { return(
                        <a className={"image_div image" + i} key={i} style={ i == 0 ? visibleImageStyle : hiddenImageStyle} {...(fi.targetUrl ? { href: fi.targetUrl } : {})}
                            data-frameitemtargeturl={fi.targetUrl} data-frameid={fi.frameId} data-frameitemid={fi.frameItemId}  data-frameitemtitle={fi.imgTitle ? fi.imgTitle : ''} data-pageframeid={frameInfo.pageFrameId}
                            onClick={imageDivClicked} draggable="false"
                        >
                            <img className="img" style={ enableImgFocalPoint && g_is_mobile ? {objectFit:'cover' , width: '100%',objectPosition: `left ${fi.focalPointX}% top ${fi.focalPointY}%`} : {} } src={fi.imageUrl} alt={fi.imgTitle} sizes={fi.imageSizes} srcSet={fi.imageSrcset} />

                            <div className={"text_overlay "  + fi.imgStyle + " " + (fi.imgShowOpacity == 1 ? 'showOpacity' : '' )} draggable="false">
                                <div className="text_contents" style={{color: fi.imgTextColor ? fi.imgTextColor : '#fff'}} draggable="false">
                                    {
                                        fi.imgTitle &&
                                        <h1 className="frame_title sg-f-dspl-l " dangerouslySetInnerHTML={{__html: fi.imgTitle }}></h1>
                                    }

                                    {
                                        fi.imgText &&
                                        <h2 className="frame_subtitle sg-f-dspl-s " >
                                            <span  dangerouslySetInnerHTML={{__html: fi.imgText }}></span>
                                            { ! fi.imgButtonText &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="42" height="10"  viewBox="0 0 47 41">
                                                    <path fill="none" stroke={fi.imgTextColor ? fi.imgTextColor : '#fff'} strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="m26.6 2 18 17-18 19M3 19h40.6"/>
                                                </svg>
                                            }
                                        </h2>
                                    }

                                    {
                                        fi.imgButtonText &&
                                        <div className="frame_btn">
                                            <div className="primaryButton button " tabIndex="0" role="button">
                                                <span className="title-container">
                                                    <span className="title" style={{color: fi.imgTextColor ? fi.imgTextColor : '#fff'}}>{fi.imgButtonText}</span>
                                                </span>
                                            </div>
                                        </div>
                                    }

                                    {
                                        fi.logoUrl && 
                                        <div className="logo_container">
                                            <img className="logo" src={fi.logoUrl} alt={fi.logoAltText} tabIndex="0" />
                                        </div>
                                    }
                                </div>
                            </div>
                        </a>
                    )})}
                </div>
            </div>

            { 
                frameInfo.frameData.length > 1 &&
                <div className="frame_nav">
                    <div className="bars">
                        {frameInfo.frameData.map((fi, i) => { return(
                            <button className={"bar_div bar_div" + i} onClick={() => navBarClicked(i, true)}  key={i}>
                                <progress 
                                    className={"bar bar" + i  + " " + (i == currentImageIndex ? "selected" : "")} 
                                    value={(i == currentImageIndex) ? Math.floor(timePassed / slideProgressUpdateInterval) : 0}
                                    max={ Math.floor(slideMoveInterval / slideProgressUpdateInterval)} 
                                ></progress>
                            </button>
                        )})}
                    </div>

                    <div className="frame_btns" >
                        <button className="pause_btn" onClick={pauseBtnClicked} style={{display: paused ? 'none' : 'block'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
                                <path fill="none" stroke="#999999" strokeWidth="2" d="M4.1 1.3V13m7-11.7V13"/>
                            </svg>

                            {false &&
                            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.61426 2V14" stroke="#999999" strokeWidth="3" strokeLinecap="round"/>
                                <path d="M9 2V14" stroke="#999999" strokeWidth="3" strokeLinecap="round"/>
                            </svg>
                            }
                        </button>

                        <button className="play_btn" onClick={playBtnClicked} style={{display: paused ? 'block' : 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
                                <path fill="#999999" fillRule="evenodd" d="m12 7-9 6V1z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            }

            <div style={{padding: '5px', display: (localStorage && localStorage.frame181_debug == '1') ? 'block' : 'none'}}>
                currentImageIndex: {currentImageIndex}, 
                timePassed: {timePassed}, 
                paused: {paused ? 1 : 0}, 
                hover: {hover ? 1 : 0}, 
                visible: {visible ? 1: 0}, 
                startX: {startX.current }
            </div>
        </div>  
    )
}

export default BannerMarquee;